(($) => {
  $(() => {
    const $cookieNotice = $('#cookie-notice');

    if ($cookieNotice.length) {
      const localStorageKey = 'cookiesAccepted';

      $cookieNotice.on('click', 'button', () => {
        localStorage.setItem(localStorageKey, true);
        $cookieNotice.hide();
      });

      if (!localStorage.getItem(localStorageKey)) {
        $cookieNotice.show();
      }
    }
  });
})(jQuery);
